(function () {
  'use strict';
  if (window.__shPickupCheckout) return;
  window.__shPickupCheckout = true;
  var pickupLocations = {
    'main-store': '35699982426',
    'location-mufadu1u': '71976386806',
    'san-mateo-farmers-market': '82534826230'
  };
  var mutation = 'mutation SetPickup($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { checkoutUrl buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } } } userErrors { field message } } }';
  var busy = false;
  var nativeSubmit = false;
  function widget() {
    var root = document.querySelector('#main-cart-footer [data-pd-app]');
    return root && root.__pdInstance;
  }
  function selection(instance) {
    if (!instance || !instance.state || !instance.state.method) throw new Error('Please wait for the pickup and delivery options to load.');
    var state = instance.state;
    var attrs = {
      _pd_method: state.method,
      _pd_location_id: '', _pd_location_name: '', _pd_pickup_date: '', _pd_pickup_time: '',
      _pd_delivery_address: '', _pd_delivery_date: '', _pd_delivery_time: ''
    };
    var preference = { deliveryMethod: ['SHIPPING'], pickupHandle: [] };
    if (state.method === 'STORE_PICKUP') {
      var location = (instance.locations || []).find(function (l) { return l.id === state.locationId && l.enablePickup; });
      if (!location || !pickupLocations[location.id]) throw new Error('Please choose a pickup location.');
      if (!state.date || !state.time) throw new Error('Please choose your pickup day and time.');
      if ((location.upcomingPickupDays || []).indexOf(state.date) === -1 || (location.timeSlots || []).indexOf(state.time) === -1) throw new Error('Please choose an available pickup day and time.');
      attrs._pd_location_id = location.id;
      attrs._pd_location_name = location.name;
      attrs._pd_pickup_date = state.date;
      attrs._pd_pickup_time = state.time;
      preference = { deliveryMethod: ['PICK_UP'], pickupHandle: [pickupLocations[location.id]] };
    } else if (state.method === 'LOCAL_DELIVERY') {
      if (!state.deliveryAddress || !state.deliveryCity || !state.deliveryZip || !state.deliveryDate || !state.deliveryTime || state.zipCheck !== true) throw new Error('Please complete your local delivery details.');
      attrs._pd_delivery_address = [state.deliveryAddress, state.deliveryCity, state.deliveryZip].join(', ');
      attrs._pd_delivery_date = state.deliveryDate;
      attrs._pd_delivery_time = state.deliveryTime;
    } else if (state.method !== 'SHIPPING' && state.method !== 'UBER_COURIER') {
      throw new Error('Please choose how you would like to receive your order.');
    }
    return { attributes: attrs, preference: preference };
  }
  async function jsonRequest(url, body) {
    var response = await fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Could not save your delivery choice. Please try Checkout again.');
    return response.json();
  }
  async function handoff(pick, form, button) {
    // Update the existing Online Store cart. No replacement cart or order is created.
    var cart = await jsonRequest((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', { attributes: pick.attributes });
    if (!cart.token || !cart.item_count) throw new Error('Your cart is empty. Please add an item first.');
    var result = await jsonRequest('/api/2026-10/graphql.json', {
      query: mutation,
      variables: { cartId: 'gid://shopify/Cart/' + cart.token, buyerIdentity: { preferences: { delivery: pick.preference } } }
    });
    var update = result.data && result.data.cartBuyerIdentityUpdate;
    if (result.errors || !update || (update.userErrors || []).length || !update.cart) throw new Error('Could not carry your delivery choice into checkout. Please try again.');
    var delivery = update.cart.buyerIdentity.preferences.delivery;
    if (delivery.deliveryMethod[0] !== pick.preference.deliveryMethod[0] || (pick.preference.deliveryMethod[0] === 'PICK_UP' && delivery.pickupHandle[0] !== pick.preference.pickupHandle[0])) throw new Error('Could not confirm your pickup location. Please try again.');
    // Keep the original Shopify checkout entry and its shipping-rate integrations.
    nativeSubmit = true;
    try { 
      button.disabled = false;
      form.requestSubmit(button);
    } finally { nativeSubmit = false; }
  }
  document.addEventListener('submit', function (event) {
    if (nativeSubmit) return;
    if (event.target.id !== 'cart' || !document.getElementById('main-cart-footer')) return;
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    var button = event.submitter;
    var error = document.getElementById('cart-errors');
    var label = button.textContent;
    if (error) { error.textContent = ''; error.setAttribute('role', 'alert'); }
    var pick;
    try { pick = selection(widget()); }
    catch (e) { if (error) error.textContent = e.message; return; }
    busy = true;
    button.disabled = true;
    button.textContent = 'Opening checkout…';
    handoff(pick, event.target, button).catch(function (e) {
      if (error) error.textContent = e.message;
      busy = false;
      button.disabled = false;
      button.textContent = label;
    });
  }, true);
})();
